import { render, staticRenderFns } from "./1V1Course.vue?vue&type=template&id=003a7e9a&scoped=true"
import script from "./1V1Course.vue?vue&type=script&lang=js"
export * from "./1V1Course.vue?vue&type=script&lang=js"
import style0 from "./1V1Course.vue?vue&type=style&index=0&id=003a7e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003a7e9a",
  null
  
)

export default component.exports